import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Arayüz ile sunucu aynı adresten servis edilir (server/server.py).
const SERVER_HTTP = "";
const POLL_MS = 1500;

export default function Login() {
  const [mail, setMail]             = useState('');
  const [sifre, setSifre]           = useState('');
  const [status, setStatus]         = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [number, setNumber]         = useState(null);
  const [codeText, setCodeText]     = useState('');
  const [loading, setLoading]       = useState(false);
  const [checking, setChecking]     = useState(true);
  const pollRef  = useRef(null);
  const loginIdRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const savedMail  = localStorage.getItem('mail');
    const savedSifre = localStorage.getItem('sifre');
    if (savedMail)  setMail(savedMail);
    if (savedSifre) setSifre(savedSifre);

    checkSession();
    return () => clearInterval(pollRef.current);
  }, []);

const checkSession = async () => {
    try {
      const appToken = localStorage.getItem('app_token');
      
      if (!appToken) {
        setChecking(false);
        return;
      }

      const res = await fetch(`${SERVER_HTTP}/check-session`, {
        headers: { 'x-app-token': appToken }
      });
      const data = await res.json();

      if (data.valid) {
        navigate('/home');
      }
    } catch (e) {
    } finally {
      setChecking(false);
    }
  };

  const stopPolling = () => clearInterval(pollRef.current);

  // Canlı ekrana girdi gönder (tıklama / metin). Sunucu bunu giriş tarayıcısına uygular.
  const sendInput = (payload) => {
    if (!loginIdRef.current) return;
    fetch(`${SERVER_HTTP}/login/input`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: loginIdRef.current, ...payload }),
    }).catch(() => {});
  };

  const onScreenClick = (e) => {
    const img = e.currentTarget;
    const r = img.getBoundingClientRect();
    sendInput({
      type: 'click',
      x: Math.round((e.clientX - r.left) * img.naturalWidth / r.width),
      y: Math.round((e.clientY - r.top) * img.naturalHeight / r.height),
    });
  };

  const sendCode = () => {
    if (!codeText) return;
    sendInput({ type: 'text', text: codeText, submit: true });
    setCodeText('');
  };

  const handleLogin = async () => {
    if (!mail || !sifre) {
      alert('Mail ve şifre gerekli!');
      return;
    }

    localStorage.setItem('mail', mail);
    localStorage.setItem('sifre', sifre);

    setLoading(true);
    setStatus('Tarayıcı açılıyor...');
    setScreenshot(null);
    setNumber(null);

    let loginId;
    try {
      const res = await fetch(`${SERVER_HTTP}/login/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mail, sifre }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Giriş başlatılamadı.');
      loginId = data.login_id;
      loginIdRef.current = loginId;
    } catch (e) {
      setLoading(false);
      setStatus(`Hata: ${e.message}`);
      return;
    }

    stopPolling();
    pollRef.current = setInterval(async () => {
      try {
        const res = await fetch(`${SERVER_HTTP}/login/status?id=${encodeURIComponent(loginId)}`);
        const data = await res.json();

        if (data.image) setScreenshot(`data:image/png;base64,${data.image}`);
        if (data.number) setNumber(data.number);

        if (data.status === 'starting') {
          setStatus('Tarayıcı açılıyor...');
        } else if (data.status === 'mfa_waiting') {
          setStatus('Microsoft sayfası yüklendi, MFA bekleniyor...');
        } else if (data.status === 'screenshot') {
          setStatus('Authenticator uygulamasında sayıyı onaylayın...');
        } else if (data.status === 'success') {
          stopPolling();
          localStorage.setItem('app_token', data.app_token);
          setLoading(false);
          setStatus('✓ Giriş başarılı!');
          setTimeout(() => navigate('/home'), 1000);
        } else if (data.status === 'error') {
          stopPolling();
          setLoading(false);
          setStatus(`Hata: ${data.message}`);
        }
      } catch (e) {
        stopPolling();
        setLoading(false);
        setStatus('Sunucuya bağlanılamadı!');
      }
    }, POLL_MS);
  };

  if (checking) {
    return (
      <div style={styles.center}>
        <div style={styles.spinner} />
        <p style={styles.checkingText}>Oturum kontrol ediliyor...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>[ OzU Room Reserver ]</h1>
      <p style={styles.subtitle}>Özyeğin Üniversitesi · Rezervasyon Botu</p>

      <div style={styles.card}>
        <label style={styles.label}>MAİL</label>
        <input
          style={styles.input}
          type="email"
          value={mail}
          onChange={e => setMail(e.target.value)}
          placeholder="mail@ozyegin.edu.tr"
        />

        <label style={styles.label}>ŞİFRE</label>
        <input
          style={styles.input}
          type="password"
          value={sifre}
          onChange={e => setSifre(e.target.value)}
          placeholder="••••••••"
          onKeyDown={e => e.key === 'Enter' && handleLogin()}
        />

        <button
          style={{...styles.btn, opacity: loading ? 0.6 : 1}}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? 'Bekleniyor...' : '[ GİRİŞ YAP ]'}
        </button>
      </div>

      {status && <p style={styles.status}>{status}</p>}

      {number && (
        <div style={styles.numberBox}>
          <p style={styles.label}>AUTHENTICATOR'DA BU SAYIYI SEÇ</p>
          <p style={styles.number}>{number}</p>
        </div>
      )}

      {screenshot && (
        <div style={styles.screenshotContainer}>
          <p style={styles.label}>CANLI EKRAN</p>
          <img
            src={screenshot}
            alt="Microsoft giriş ekranı"
            style={{ ...styles.screenshot, cursor: loading ? 'pointer' : 'default' }}
            onClick={loading ? onScreenClick : undefined}
          />
          {loading && (
            <>
              <p style={styles.hint}>
                Bildirim gelmediyse: yukarıdaki ekrandaki bağlantıya tıkla (ör. "Şu an kullanamıyorum" →
                doğrulama kodu seç), sonra Authenticator uygulamasındaki 6 haneli kodu aşağıya yaz.
              </p>
              <div style={styles.codeRow}>
                <input
                  style={{ ...styles.input, flex: 1, marginBottom: 0 }}
                  value={codeText}
                  onChange={e => setCodeText(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && sendCode()}
                  placeholder="Doğrulama kodu / metin"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                />
                <button style={styles.btn} onClick={sendCode}>[ GÖNDER ]</button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  center: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#0f0f0f',
    gap: '16px',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #2a2a2a',
    borderTop: '3px solid #e8ff5a',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  checkingText: {
    color: '#888',
    fontSize: '14px',
  },
  container: {
    maxWidth: '480px',
    margin: '0 auto',
    padding: '32px 24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#e8ff5a',
    marginBottom: '4px',
  },
  subtitle: {
    fontSize: '12px',
    color: '#888',
    marginBottom: '24px',
  },
  card: {
    backgroundColor: '#1a1a1a',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #2a2a2a',
    marginBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    color: '#e8ff5a',
    fontSize: '11px',
    fontWeight: 'bold',
  },
  input: {
    backgroundColor: '#0f0f0f',
    color: '#f0f0f0',
    padding: '12px',
    borderRadius: '4px',
    border: '1px solid #2a2a2a',
    fontSize: '14px',
    fontFamily: 'Courier New',
    outline: 'none',
    marginBottom: '8px',
  },
  btn: {
    backgroundColor: '#e8ff5a',
    color: '#0f0f0f',
    padding: '14px',
    borderRadius: '4px',
    border: 'none',
    fontWeight: 'bold',
    fontSize: '14px',
    fontFamily: 'Courier New',
    cursor: 'pointer',
    marginTop: '8px',
  },
  status: {
    color: '#888',
    fontSize: '13px',
    textAlign: 'center',
    marginBottom: '16px',
  },
  hint: {
    color: '#888',
    fontSize: '12px',
    margin: '12px 0 8px',
    lineHeight: '1.5',
  },
  codeRow: {
    display: 'flex',
    gap: '8px',
  },
  numberBox: {
    backgroundColor: '#1a1a1a',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid #e8ff5a',
    textAlign: 'center',
    marginBottom: '16px',
  },
  number: {
    color: '#e8ff5a',
    fontSize: '64px',
    fontWeight: 'bold',
    fontFamily: 'Courier New',
    margin: '8px 0 0',
  },
  screenshotContainer: {
    backgroundColor: '#1a1a1a',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid #2a2a2a',
  },
  screenshot: {
    width: '100%',
    borderRadius: '4px',
    marginTop: '8px',
  },
};